/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  RescuePlan,
  RescuePlanDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiRescueplanProjectId = (
    projectId: number,
 signal?: AbortSignal
) => {


      return customInstance<RescuePlanDto>(
      {url: `/api/Rescueplan/${projectId}`, method: 'GET', signal
    },
      );
    }




export const getGetApiRescueplanProjectIdQueryKey = (projectId: number,) => {
    return [
    `/api/Rescueplan/${projectId}`
    ] as const;
    }


export const getGetApiRescueplanProjectIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError = ErrorType<unknown>>(projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiRescueplanProjectIdQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRescueplanProjectId>>> = ({ signal }) => getApiRescueplanProjectId(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiRescueplanProjectIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiRescueplanProjectId>>>
export type GetApiRescueplanProjectIdQueryError = ErrorType<unknown>


export function useGetApiRescueplanProjectId<TData = Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRescueplanProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiRescueplanProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRescueplanProjectId<TData = Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRescueplanProjectId>>,
          TError,
          Awaited<ReturnType<typeof getApiRescueplanProjectId>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiRescueplanProjectId<TData = Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiRescueplanProjectId<TData = Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError = ErrorType<unknown>>(
 projectId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRescueplanProjectId>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiRescueplanProjectIdQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putApiRescueplan = (
    rescuePlanDto?: BodyType<RescuePlanDto>,
 signal?: AbortSignal
) => {


      return customInstance<RescuePlan>(
      {url: `/api/Rescueplan`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: rescuePlanDto, signal
    },
      );
    }




export const getPutApiRescueplanMutationKey = () => ['putApiRescueplan'] as const;

export const getPutApiRescueplanMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiRescueplan>>, TError,PutApiRescueplanMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiRescueplan>>, TError,PutApiRescueplanMutationVariables, TContext> => {

const mutationKey = getPutApiRescueplanMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiRescueplan>>, PutApiRescueplanMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  putApiRescueplan(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiRescueplanMutationResult = NonNullable<Awaited<ReturnType<typeof putApiRescueplan>>>
    export type PutApiRescueplanMutationBody = BodyType<RescuePlanDto> | undefined
    export type PutApiRescueplanMutationError = ErrorType<unknown>
    export type PutApiRescueplanMutationVariables = {data?: BodyType<RescuePlanDto>}

    export const usePutApiRescueplan = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiRescueplan>>, TError,PutApiRescueplanMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiRescueplan>>,
        TError,
        PutApiRescueplanMutationVariables,
        TContext
      > => {
      return useMutation(getPutApiRescueplanMutationOptions(options), queryClient);
    }
